


const PageTwo = () => {
  return (
    <>
      <div className="flex items-start space-x-4">
        <img 
          src="/lovable-uploads/clr_4.png" 
          alt="Bromentum Logo" 
          className="w-8 h-8 object-contain mt-2"
        />
        <div>
          <p className="text-xl font-bold text-foreground">Honor</p>
          <p className="text-xl text-foreground">Every challenge is a mirror. Your code is always watching.</p>
        </div>
      </div>
      
      <div className="flex items-start space-x-4 mt-4">
        <img 
          src="/lovable-uploads/clr_4.png" 
          alt="Bromentum Logo" 
          className="w-8 h-8 object-contain mt-2"
        />
        <div>
          <p className="text-xl font-bold text-foreground">Clout</p>
          <p className="text-xl text-foreground">BroScore is your social weight. It is public.</p>
        </div>
      </div>
      
      <div className="flex items-start space-x-4 mt-4">
        <img 
          src="/lovable-uploads/clr_4.png" 
          alt="Bromentum Logo" 
          className="w-8 h-8 object-contain mt-2"
        />
        <div>
          <p className="text-xl font-bold text-foreground">Proof</p>
          <p className="text-xl text-foreground">No screenshots = no story. IPFS, video, and votes prove truth.</p>
        </div>
      </div>
      
      <div className="flex items-start space-x-4 mt-4">
        <img 
          src="/lovable-uploads/clr_4.png" 
          alt="Bromentum Logo" 
          className="w-8 h-8 object-contain mt-2"
        />
        <div>
          <p className="text-xl font-bold text-foreground">Ritual</p>
          <p className="text-xl text-foreground">Discipline, daily. Your resistance is your ritual.</p>
        </div>
      </div>
      
      <div className="flex items-start space-x-4 mt-4">
        <img 
          src="/lovable-uploads/clr_4.png" 
          alt="Bromentum Logo" 
          className="w-8 h-8 object-contain mt-2"
        />
        <div>
          <p className="text-xl font-bold text-foreground">Rematch</p>
          <p className="text-xl text-foreground">You didn't lose. You're just not finished yet.</p>
        </div>
      </div>
    </>
  );
};

export default PageTwo;
